import React from 'react';
import { Box, Chip } from '@mui/material';
import { IBadgeCellValue } from './interfaces';

export const BadgeCellValue: React.FC<IBadgeCellValue> = ({
  label,
  color,
  variant,
  size = 'small',
}): JSX.Element => {
  return (
    <Box
      sx={{
        height: '100%',
      }}
    >
      <Chip label={label} color={color} variant={variant} size={size} />
    </Box>
  );
};
